import { render, staticRenderFns } from "./LogoDialog.vue?vue&type=template&id=63ee6d3a&scoped=true"
import script from "./LogoDialog.vue?vue&type=script&lang=js"
export * from "./LogoDialog.vue?vue&type=script&lang=js"
import style0 from "./LogoDialog.vue?vue&type=style&index=0&id=63ee6d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ee6d3a",
  null
  
)

export default component.exports